





































































import { DoseUnit, DoseUnitEnum, SelectItem } from "@/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ToDose extends Vue {
  @Prop()
  private weight!: number;

  name = "ToDose";

  private syringeDose = 0; // davka ve strikacce
  private syringeSize = 100; // velikost strikacky
  private syringeSizes: SelectItem[] = [
    {
      value: 250,
      title: "250 ml",
    },
    {
      value: 100,
      title: "100 ml",
    },
    {
      value: 50,
      title: "50 ml",
    },
    {
      value: 40,
      title: "40 ml",
    },
    {
      value: 20,
      title: "20 ml",
    },
    {
      value: 10,
      title: "10 ml",
    },
  ];
  private rate = 0; // Tempo Infuze
  private doseUnit = 0; // jednotka pozadovane davky
  private doseUnits: DoseUnit[] = [
    {
      value: DoseUnitEnum["µg/kg/min"],
      title: "µg/kg/min",
    },
    {
      value: DoseUnitEnum["µg/kg/hod"],
      title: "µg/kg/hod",
    },
    {
      value: DoseUnitEnum["µg/min"],
      title: "µg/min",
    },
    {
      value: DoseUnitEnum["mg/hod"],
      title: "mg/hod",
    },
    {
      value: DoseUnitEnum["mg/kg/hod"],
      title: "mg/kg/hod",
    },
  ];

  get dose(): number {
    let x = this.rate;
    if (
      ![DoseUnitEnum["µg/min"], DoseUnitEnum["mg/hod"]].includes(this.doseUnit)
    )
      x = this.rate / this.weight;
    let dose = (x * this.syringeDose) / this.syringeSize;
    switch (this.doseUnit) {
      case DoseUnitEnum["µg/kg/min"]:
      case DoseUnitEnum["µg/min"]:
        dose = dose / 0.06;
        break;
      case DoseUnitEnum["µg/kg/hod"]:
        dose = dose * 1000;
        break;
    }
    return Math.round(dose * 10) / 10;
  }
}
